// project import

import { getColors } from "utils";

// ==============================|| CHIP - COLORS ||============================== //

function getColor({ color, theme }) {
  const colors = getColors(theme, color);
  const { dark } = colors;

  return {
    "&.Mui-focusVisible": {
      outline: `2px solid ${dark}`,
      outlineOffset: 2,
    },
  };
}

function getColorStyle({ color, theme }) {
  const colors = getColors(theme, color);
  const { light, lighter, main } = colors;

  return {
    color: main,
    backgroundColor: lighter,
    borderColor: light,
    "& .MuiChip-deleteIcon": {
      color: main,
      "&:hover": {
        color: light,
      },
    },
  };
}

// ==============================|| OVERRIDES - CHIP ||============================== //

export default function Chip(theme) {
  const defaultLightChip = getColorStyle({ color: "secondary", theme });
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          // borderRadius: 4,
          fontWeight: 500,
          fontSize: "0.75rem",
          color: "#344054",
          backgroundColor: "#F2F4F7",
          borderColor: "#F2F4F7",

          "&:active": {
            boxShadow: "none",
          },
          "&.MuiChip-colorPrimary": getColor({ color: "primary", theme }),
          "&.MuiChip-colorSecondary": getColor({ color: "secondary", theme }),
          "&.MuiChip-colorError": getColor({ color: "error", theme }),
          "&.MuiChip-colorInfo": getColor({ color: "info", theme }),
          "&.MuiChip-colorSuccess": getColor({ color: "success", theme }),
          "&.MuiChip-colorWarning": getColor({ color: "warning", theme }),
        },
        sizeLarge: {
          fontSize: "1rem",
          height: 40,
        },
        light: {
          ...defaultLightChip,
          "&.MuiChip-colorPrimary": getColorStyle({ color: "primary", theme }),
          "&.MuiChip-colorSecondary": getColorStyle({
            color: "secondary",
            theme,
          }),
          "&.MuiChip-colorError": getColorStyle({ color: "error", theme }),
          "&.MuiChip-colorInfo": getColorStyle({ color: "info", theme }),
          "&.MuiChip-colorSuccess": getColorStyle({ color: "success", theme }),
          "&.MuiChip-colorWarning": getColorStyle({ color: "warning", theme }),
        },
        combined: {
          border: "1px solid",
          ...defaultLightChip,
          "&.MuiChip-colorPrimary": getColorStyle({
            color: "primary",
            theme,
          }),
          "&.MuiChip-colorSecondary": getColorStyle({
            color: "secondary",
            theme,
          }),
          "&.MuiChip-colorError": getColorStyle({ color: "error", theme }),
          "&.MuiChip-colorInfo": getColorStyle({ color: "info", theme }),
          "&.MuiChip-colorSuccess": getColorStyle({
            color: "success",
            theme,
          }),
          "&.MuiChip-colorWarning": getColorStyle({
            color: "warning",
            theme,
          }),
        },
      },
    },
  };
}
